export interface NoteListSaveButtonClickOutput {
    content?: string;
    index?: number;
}
